import PropTypes from 'prop-types';
import React, {Component} from "react";
import {Button, Container, Divider, Menu} from "semantic-ui-react";
import LanguageDropdown from "../../localisation/LanguageDropdown";
import {Translate} from "react-localize-redux";

class DesktopMenu extends Component {

  static propTypes = {
    fixed: PropTypes.bool.isRequired
  };

  render() {
    return (
      <Menu
        fixed={this.props.fixed ? 'top' : null}
        inverted={!this.props.fixed}
        pointing={!this.props.fixed}
        secondary={!this.props.fixed}
        size='large'
      >
        <Container>
          <Menu.Item as='a' active>
            <Translate id="home"/>
          </Menu.Item>
          <Divider inverted/>

          <Menu.Item position='right'>
            <LanguageDropdown/>
            <Button color='spotify' icon='spotify' href={"https://open.spotify.com/artist/2yMSEhkGq1uUFAIcaSBTfs"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}}/>
            <Button color='itunes' icon='itunes' href={"https://itunes.apple.com/us/artist/latent-signal/1403709614"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}}/>
            <Button color='google' icon='google' href={"https://play.google.com/store/music/artist/Latent_Signal?id=Ab2zr5y2obkytl2zxxge24rgwnm"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}}/>
            <Button color='facebook' icon='facebook' href={"https://www.facebook.com/latentsignal/"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}}/>
            <Button color='twitter' icon='twitter' href={"https://twitter.com/latentsignal"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}} />
            <Button color='instagram' icon='instagram' href={"https://www.instagram.com/latentsignal"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}}/>
            <Button color='soundcloud' icon='soundcloud' href={"https://soundcloud.com/latentsignal"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}} />
            <Button color='youtube' icon='youtube' href={"https://www.youtube.com/channel/UCqQdwJ5W-FDAin_Hc6oHz_A"} inverted={!this.props.fixed} style={{marginLeft: '0.5em'}}/>
          </Menu.Item>
        </Container>
      </Menu>
    )
  }
}

export default DesktopMenu



// WEBPACK FOOTER //
// ./src/components/desktop/DesktopMenu.js